import DatePicker from "react-datepicker";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import React, { FC, Fragment, useContext, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcInputNumber from "./NcInputNumber";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { GlobalDataContext } from "contexts/GlobalData";
import { Navigate, useNavigate } from "react-router-dom";
import { UIContext } from "contexts/UIContext";
import { requestAPI } from "utils/api";
import SigninForm from "components_custom/SigninForm/SigninForm";

interface ModalSelectDateProps {
  renderChildren?: (p: { openModal: () => void }) => React.ReactNode;
  id: any;
  info: any;
 
}

const ModalMobileOrder: FC<ModalSelectDateProps> = ({ 
	renderChildren,
	id,
	info,
}) => {

	console.log(`r11 info @@@@@@@@@@@@@@@`, info)

	const {
		toast,
		modal,
	} = useContext(UIContext);  
	const { 
		initData,
		get,
		set,
	} = useContext (GlobalDataContext);

	const navigate = useNavigate ();

	const [showModal, setShowModal] = useState(false);
	const [guestAdultsInputValue, setGuestAdultsInputValue] = useState(1);
	const [orderAmount, setOrderAmount] = useState(info.price * guestAdultsInputValue);
	const [newOrderAmounts, setNewOrderAmounts] = useState([]);

	useEffect(() => {
		const _newOrderAmounts: any = [];
		
		info.priceOptions.map((item: any) => {
			_newOrderAmounts.push({
				label: item.label,
				price: item.price,
				isRider: item.isRider,
				amount: 0
			})
		})

		setNewOrderAmounts(_newOrderAmounts);
	}, []);

	const handleChangeData = (index: number, value: number, type: any) => {
		const _newOrderAmounts: any = [...newOrderAmounts];

		_newOrderAmounts[index].amount = value;

		setNewOrderAmounts(_newOrderAmounts);
	};

	// const handleChangeData = (value: number, type: any) => {
	// 	let newValue = {
	// 		guestAdults: guestAdultsInputValue,
	// 	};

	// 	if (type === "guestAdults") {
	// 		setGuestAdultsInputValue(value);
	// 		newValue.guestAdults = value;
	// 		setOrderAmount(info.price * value);
	// 	}
	// };

	function closeModal() {
		setShowModal(false);
	}

	function openModal() {
		if (initData.token_info.permission_group === "guest") {
				
			modal({
				title: "로그인", 
				contents: <SigninForm modalSw={true} />,
				buttons: []
			});	

			return toast ({
				type: 'warning', 
				contents: '로그인이 필요해요'
			});
		}
		setShowModal(true);
	}

	const renderButtonOpenModal = () => {
		return renderChildren ? (
		renderChildren({ openModal })
		) : (
			<ButtonPrimary
				sizeClass="px-5 sm:px-7 py-3 !rounded-2xl"
				onClick={openModal}
			>
				예약하기
			</ButtonPrimary>
		);
	};

	const handleReserve = async () => {

		let sum = 0;

		newOrderAmounts.forEach((item: any) => {
			sum  = sum + item.amount;
		});

		//console.log(">> >> >> ", newOrderAmounts);

		if (sum === 0) {
			toast ({
				type: 'warning', 
				contents: "인원을 선택해 주세요"
			});
			
			return; // Exit the function early if no valid amounts
		}

		setShowModal(false);

		//return

		await set("productOrderInfo", {
			product_no: Number(id),
			user_no: Number(initData.token_info.user_no),
			price: info.price,
			orderAmount,
			guestAdultsInputValue,
			newOrderAmounts
		});

		modal({
			title: "주문확인", 
			contents: `확인 버튼을 누르면 신청하신 인원 (${guestAdultsInputValue}명)이 예약돼요!`,
			buttons: [{
				label: '취소',
				color: 'ButtonSecondary',
				fn: () => {
					modal({title: "CLOSE", contents: "", buttons: []});	
				}
			},
			{
				label: '확인',
				color: 'ButtonPrimary',
				fn: async () => {return new Promise(async (resolve: any, reject: any) => {    

					const res_info: any = await requestAPI ('POST', `v1/reserve/${id}`, {
						guestAdultsInputValue,
						orderAmount,
						newOrderAmounts
					});

					if (res_info.code === 1000) {
						modal({title: "CLOSE", contents: "", buttons: []});	
						navigate(`/checkout/${res_info.data.info._id}`);

						resolve(1);
					} else if (res_info.code === 4000) {
						modal({title: "CLOSE", contents: "", buttons: []});	
						toast ({
							type: 'warning', 
							contents: "이미 신청 내역이 있어요"
						});
						resolve(1);
					} else {
						reject(-1);
					}

				});}
			}]
		});

		
	};

  return (
    <>
      {renderButtonOpenModal()}
      <Transition appear show={showModal} as={Fragment}>
        <Dialog
          as="div"
          className="HeroSearchFormMobile__Dialog relative z-50"
          onClose={closeModal}
        >
          <div className="fixed w-full bg-neutral-100 dark:bg-neutral-900 bottom-0 h-[400px] !bg-opacity-75">
            <div className="flex h-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out transition-transform"
                enterFrom="opacity-0 translate-y-52"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in transition-transform"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-52"
              >
                <Dialog.Panel className="relative h-full overflow-hidden flex-1 flex flex-col justify-between ">
					<>
						<div className="w-full flex justify-center absolute top-4 ">
							<button
								className="focus:outline-none focus:ring-0 w-[60px] h-[40px] bg-white dark:bg-neutral-800 rounded-tl-lg rounded-tr-lg"
								onClick={closeModal}
							>
								<i className="las la-chevron-down text-black dark:text-white"></i>
							</button>
						</div>

						<div className="flex-1 pt-12 p-0 flex flex-col overflow-auto">
							<div className="flex-1 flex flex-col bg-white dark:bg-neutral-800">
								<div className="flex-1 flex flex-col transition-opacity animate-[myblur_0.4s_ease-in-out] overflow-auto">
									<div className="p-5 ">
										<span className="block font-semibold text-xl sm:text-2xl">
											{`인원`}
										</span>
									</div>
									<div className="flex-1 relative flex z-10 ">
										<div className="overflow-hidden rounded-3xl ">

											{info.priceOptions.map ((item: any, index: number) => (
												<NcInputNumber
													className="m-4"
													defaultValue={0}
													handleChangeData={handleChangeData}
													max={10}
													min={0}
													label={item.label}
													price={item.price}
													index={index}
												/>
											))}

											
										</div>
									</div>
									<div className="flex flex-col space-y-4 mb-5 ml-4 mr-4">
										<div className="border-b border-neutral-200 dark:border-neutral-700" />
										<div className="flex justify-between font-semibold">
											<span>Total</span>
											<span>{Number(orderAmount).toLocaleString('ko-KR')}</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="px-4 py-3 bg-white dark:bg-neutral-900 border-t border-neutral-200 dark:border-neutral-700 flex justify-between">
							
							<ButtonSecondary
								sizeClass="px-6 py-3 !rounded-xl"
								onClick={() => {
									closeModal();
								}}
							>
								취소
							</ButtonSecondary>
							<ButtonPrimary
								sizeClass="px-6 py-3 !rounded-xl"
								onClick={() => handleReserve()}
							>
								예약
							</ButtonPrimary>
						</div>
					</>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default ModalMobileOrder;
